import React from "react";
import format from "date-fns/format";
import PropTypes from "prop-types";

import DownloadMessage from "core/DownloadMessage";
import DownloadPhotoButton from "./DownloadPhotoButton";

import { StyledProDownloadSection } from "./styles";

const ProDownloadSection = ({ downloadType, photo }) => {
    return (
        <StyledProDownloadSection data-testid="pro-download-section">
            <DownloadMessage photo={photo} />
            <DownloadPhotoButton downloadType={downloadType} photoId={photo.id}>
                Download JPG
            </DownloadPhotoButton>
        </StyledProDownloadSection>
    );
};

ProDownloadSection.propTypes = {
    downloadType: PropTypes.string.isRequired,
    photo: PropTypes.object.isRequired
};

export default ProDownloadSection;
